import { Stack, Skeleton, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import type { To } from 'react-router'

import { unit, COLORS } from '@hcr/ui'

import { LayoutNavigationBack } from '../../common'

interface AccountEditLoadingProps {
  to: To
}

export const AccountEditLoading: FC<AccountEditLoadingProps> = ({ to }) => {
  const { t } = useTranslation()

  return (
    <LayoutNavigationBack to={to} arrowVariant='text'>
      <Stack sx={{ padding: `${unit(24)} ${unit(7)} ${unit(5)}`, backgroundColor: COLORS.white, gap: unit(6) }}>
        <Typography variant='headlineS'>{t('account-edit.contact-details')}</Typography>

        <Stack gap={unit(5)}>
          <Stack gap={unit(3)}>
            <Typography variant='uppercaseExtraSmall'>{t('account-edit.basic-info')}</Typography>
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />

            <Typography variant='uppercaseExtraSmall'>{t('account-edit.address')}</Typography>
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />

            <Typography variant='uppercaseExtraSmall'>{t('account-edit.phone-number')}</Typography>
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width='100%' height={unit(14)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
          </Stack>
        </Stack>
      </Stack>
    </LayoutNavigationBack>
  )
}
